module.exports = __webpack_public_path__ + "static/bertens-gray-b210f6f8f3a8a2c92aa8d6ce00e851a7.png";